<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🎉 Cats love to keep themselves and their finances clean! 🎉</h2>
  
          <iframe height="300" style="width: 100%;" scrolling="no" title="Money Laundering" src="https://codepen.io/Farah-Kamal/embed/BaMVBKV/36164c5c3e8086be9561eece2f888927?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
    See the Pen <a href="https://codepen.io/Farah-Kamal/pen/BaMVBKV/36164c5c3e8086be9561eece2f888927">
    Money Laundering</a> by Farah Kamal (<a href="https://codepen.io/Farah-Kamal">@Farah-Kamal</a>)
    on <a href="https://codepen.io">CodePen</a>.
  </iframe>
  
          <p>🐾 "In the meticulous world of RiskyPaws, where every coin purrs with a story, we understand the importance of keeping our paws clean, especially when it comes to money. Just like a cat meticulously grooms its fur, we must be equally diligent in grooming our financial transactions. 🧹</p>
  
    
          <p> Enter the arena of Anti-Money Laundering (AML), a crucial realm where vigilance is key, and transparency is the golden rule. Imagine each transaction as a ball of yarn; if it’s over $10,000, it catches the special eye of FINTRAC – the financial world's keen-eyed owl. 🦉
  
  Why, you ask? It's simple. Large transactions, like a big fish to a curious cat, can often be enticing for those with mischievous intentions. By reporting these big catches to FINTRAC, we ensure that our financial pond stays clear, clean, and free of any sneaky piranhas. 🐟
  </p>
  
  <p>Keeping a full paper trail of your funds is like having a map of all the places you’ve been with your favorite ball of yarn. It’s smart, it’s safe, and it’s the mark of a wise cat who knows the value of every step it takes. 🗺️
  
  In RiskyPaws, KYC isn’t just 'Know Your Customer'; it’s 'Know Your Cash' too. It's about understanding the journey of every dollar and cent, ensuring they’re following the path of integrity. After all, in our world, financial safety is just as important as landing on our feet! 💼🐱
  
  So, let's embrace the art of financial grooming with AML practices. It's not just about staying within the lines of the law; it’s about weaving a tapestry of trust, transparency, and purr-fect compliance in our cozy financial abode." 🏡🌟</p>
  
  
  
  
        </div>
  
         
  </div>
  </div><br><br><br><br><br><br>
  </template>
  
  
  <script>
  </script>
  
  
  
  <style scoped>
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  .stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
  }
  
  .stylish-links ul {
  list-style: none;
  padding: 0;
  }
  
  .stylish-links ul li {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  }
  
  .stylish-links ul li a {
  color: black;
  text-decoration: none;
  font-weight: bold;
  }
  
  .stylish-links ul li:hover {
  background-color: #4A148C;
  }
  
  .stylish-links ul li:hover a {
  color: #fff;
  }
  </style>